import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../_services';
//import { AuthenticationService } from '../_services';
@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private storageService:StorageService
        // private authenticationService: AuthenticationService
    ) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const currentUser = this.storageService.getItem('SignIn');
        if (currentUser) {
            let stateUrl = state.url.replace('/apps/', "");
            // console.log(currentUser,stateUrl);
            // const roleId = currentUser.role_id;
            // const forbiddenUrls = [];
            // switch(roleId) {
            //     case 2:
            //     case 3:
            //         forbiddenUrls.push('dashboard');
            // }
            // if(forbiddenUrls.indexOf(stateUrl) !== -1)
            //     return false
            return true;
        }
        // not logged in so redirect to home page with the return url
        //this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
        else {
            this.router.navigate(['/apps/login']);
            //console.log('login');
            return false;
        }
    }
}